import { useEffect, useState } from "react";
import { XCircleIcon } from "@heroicons/react/outline";

const NotificationToast = ({ notif }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setVisible(false), 5000); 
        return () => clearTimeout(timer);
    }, []);

    if (!visible) return null;

    return (
        <div className={`flex items-center max-w-sm p-4 rounded-lg shadow-lg
            ${notif.type === "user" ? "bg-blue-500 text-white" : "bg-green-500 text-white"}
        `}>
            <span className="text-lg">{notif.message}</span>
            <button onClick={() => setVisible(false)} className="ml-auto">
                <XCircleIcon className="h-5 w-5 text-white hover:text-gray-300" />
            </button>
        </div>
    );
};

export default NotificationToast;